import axios from './axios';

export default {
  list(semester) {
    return axios.get('/evaluations', { params: { semester } });
  },
  progression() {
    return axios.get('/evaluations/progression');
  },
  facultyMarks(semester) {
    return axios.get(`/evaluations/faculty_marks?semester=${semester}`);
  },
};
